import { LayoutSubheader } from '../../_metronic';
import { IBreadcrumb } from '../interfaces/breadcrumb';

interface IProps {
  title?: string;
  breadcrumb?: IBreadcrumb[] | undefined;
  description?: string;
  back?: boolean;
}

export const setLayoutSubheader = ({
  title = '',
  breadcrumb = [],
  description = '',
  back,
}: IProps) => {
  LayoutSubheader({ title, breadcrumb, description, back });
};
